import {useQuery} from '@tanstack/react-query'
import api from 'src/services/api'
import {QueryKeyEnum} from 'src/utilities/enums/QueryKeyEnum'
import {HeatmapDetectionsType} from '../../../pages/dashboard/components/HeatMapCard'

type Props = {
  enabled?: boolean
  start: string
  end: string
  cameras: Array<number>
}

export default function useDashboardHeatMap({enabled, start, end, cameras}: Props) {
  const query = useQuery({
    enabled,
    refetchOnWindowFocus: false,
    queryKey: [QueryKeyEnum.DASHBOARD_HEATMAP, enabled, start, end, cameras],
    queryFn: async () => {
      const maxCameras = Math.min(cameras.length, 2)

      const heatmapResponses = await Promise.all(
        cameras.slice(0, maxCameras).map((cameraId) => api.reports.getHeatmapData({cameraId, start, end}).then((res) => res.data.data)),
      )

      const detections: HeatmapDetectionsType[] = []
      heatmapResponses.forEach((response) => {
        Object.entries(response.detections).forEach(([objectName, points]) => {
          detections.push({
            cameraId: response.cameraId,
            width: response.width,
            height: response.height,
            objectName,
            detections: points,
          })
        })
      })
      return detections
    },
  })

  return query
}
